"use client"
import React, { useState, useEffect } from 'react'
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import useDebounce from '@/library/utils/debounce';
import { useRouter } from 'next/navigation';

export default function SearchDefault(props) {
  const {
    onChange = () => {},
    searchThreshold = 3,
    debounceTime = 300,
    initialValue = "",
    urlParameter = "query",
    placeholder = "Search...",
  }  = props
  const router = useRouter();
  const [searchQuery, setSearchQuery ] = useState(router[urlParameter] || initialValue)


  const triggerOnChange = useDebounce(() => {
    if(searchQuery.length > searchThreshold || searchQuery.length == 0) {
      onChange({target: {name: urlParameter, value: searchQuery}})
    }
  }, debounceTime)

  useEffect(() => {
    triggerOnChange()
  }, [searchQuery])

  const handleOnSearchQueryChange = e => {
    const name = e.target.name
    const value = e.target.value
    setSearchQuery(value)
    
  }


  return (
    <div>
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        type="search"
        name="query"
        placeholder={placeholder}
        className="max-w-xs rounded-lg bg-background pl-8"
        value={searchQuery}
        onChange={handleOnSearchQueryChange}
      />
    </div>
  )
}
